import { isOKErrorCode } from './create-error-code';
import Toast from '@src/business-components/common-message';
import ServiceResponseError from '@src/error/ServiceResponseError';

// noinspection SpellCheckingInspection
window.addEventListener('unhandledrejection', event => {
  const { reason } = event;
  if (!reason) {
    return;
  }

  const { code } = reason;
  /**
   * 忽略允许忽略的代码
   */
  if (isOKErrorCode(code)) {
    event.preventDefault();
    return;
  }

  if (event && event.reason && event.reason instanceof ServiceResponseError) {
    const { message } = event.reason;
    console.error('异常被抛掷顶层, 存在性能问题');
    Toast.fail(message);
    return;
  }

  // noinspection JSUnresolvedVariable
  if (typeof window.Raven !== 'undefined') {
    event.preventDefault();

    // noinspection SpellCheckingInspection

    if (event && event.reason && typeof event.reason === 'string' && event.reason.indexOf('useRequest has caught the exception') > -1) {
      return;
    }

    window.Raven.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  } else {
    throw event;
  }
});

window.addEventListener('error', function(event) {
  const { error } = event;

  if (error) {
    const { code, reason } = error;

    if (reason && typeof reason === 'string' && reason.indexOf('useRequest has caught the exception') > -1) {
      event.preventDefault();
      return;
    }

    /**
     * 忽略允许忽略的代码
     */
    if (isOKErrorCode(code)) {
      event.preventDefault();
      return;
    }

    // noinspection JSUnresolvedVariable
    if (typeof window.Raven !== 'undefined') {
      event.preventDefault();
      window.Raven.captureException(error);
    } else {
      throw event;
    }
  }
});
